import { create } from 'zustand';

interface NavigationState {
  previousLocation: {
    pathname: string;
    state?: {
      scrollPosition?: number;
      modalOpen?: boolean;
      verseId?: string;
    };
  } | null;
  setPreviousLocation: (location: NavigationState['previousLocation']) => void;
  clearPreviousLocation: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  previousLocation: null,
  setPreviousLocation: (location) => set({ previousLocation: location }),
  clearPreviousLocation: () => set({ previousLocation: null }),
}));
